







































import { Component, Vue, Watch } from "vue-property-decorator";
import { padHeadPanel2 } from "@/components";
import dayjs from "dayjs";
import { TbNotice } from "@/http";

@Component({
  components: {
    padHeadPanel2,
  },
})
export default class notice extends Vue {
  public $refs: {
    inventoryDetail: HTMLFormElement;
  };

  list: any = [];
  curid = "";
  curhtml = "";
  form: any = {};

  async created() {
    await this.getlist();
    this.curid = this.list && this.list.length > 0 ? this.list[0].id : "";
    if (this.curid) {
      await this.getDetail();
    }
  }

  async getlist() {
    try {
      let res = await TbNotice.GetTbNoticeList({
        skip: 0,
        count: -1,
      });
      this.list = res.items.map((v) => {
        return {
          ...v,
          createTime: dayjs(v.createTime).format("YYYY-MM-DD"),
        };
      });
    } catch (error) {}
  }
  async getDetail() {
    try {
      let res = await TbNotice.GetTbNoticeById({
        id: this.curid,
      });
      this.form = res;
      this.form.createTime = res.createTime;
    } catch (error) {}
  }
  async gotodetail(item) {
    this.curid = item.id;
    await this.getDetail();
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/notice/notice.vue